export { default } from './TreeItem';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TreeItem/index.js
// module id = 903
// module chunks = 2